import { render, staticRenderFns } from "./MonthOrder.vue?vue&type=template&id=5212a434&scoped=true"
import script from "./MonthOrder.vue?vue&type=script&lang=js"
export * from "./MonthOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5212a434",
  null
  
)

export default component.exports